/* components/HalloweenCollection.tsx llevado a JavaScript sin dependencias. */
(function () {
  var root = document.querySelector('[data-hw]');
  if (!root) return;

  var models = JSON.parse(document.querySelector('[data-hw-models]').textContent);
  var products = {};
  try { products = JSON.parse(document.querySelector('[data-hw-products]').textContent); } catch (e) {}
  var ASSETS = window.AetheriaHalloweenAssets || '';
  var STORAGE = 'aetheria-halloween-selection-v1';
  var GROUPS = ['Calabazas', 'Fantasmas', 'Calaveras y huesos', 'Arañas, murciélagos y gatos', 'Brujas y calderos', 'Casas, lápidas y carteles', 'Pequeños detalles'];
  var PACKS = [
    { name: 'Rincón encantado', text: 'Una casa con luz, una calabaza y un pequeño espíritu para tu rincón favorito.', ids: ['604462', '576649', '1054054'] },
    { name: 'Mesa de medianoche', text: 'Una calavera, un caldero y arañas para una escena que no pasa desapercibida.', ids: ['278015', '287930', '618300'] },
    { name: 'Tu escaparate embrujado', text: 'Altura, luz y un mensaje propio. Una composición pensada para negocios.', ids: ['642095', '609235', '299289'] }
  ];
  /* CC-BY y CC-BY-SA obligan a enlazar el texto de la licencia, no solo a nombrarla. */
  var LICENSE_URL = {
    'CC-BY': 'https://creativecommons.org/licenses/by/4.0/deed.es',
    'CC-BY-SA': 'https://creativecommons.org/licenses/by-sa/4.0/deed.es'
  };

  var fmt = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 });
  var euro = function (c) { return fmt.format(c / 100); };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  };
  var normalize = function (s) { return s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase(); };
  // Portada de campaña (recreación con IA) si existe; si no, la foto del autor.
  var photo = function (p) { return ASSETS + (p.cover || p.image); };
  var find = function (id) { return models.filter(function (p) { return p.id === id; })[0]; };
  var buyable = function (id) { return products[id]; };
  var priceLabel = function (p) { return p.grossCents != null ? euro(p.grossCents) : 'A presupuestar'; };
  var label = function (p) { var b = buyable(p.id); return b ? euro(b.priceCents) : priceLabel(p); };
  var license = function (l) {
    return LICENSE_URL[l] ? '<a href="' + LICENSE_URL[l] + '" target="_blank" rel="license noopener noreferrer">' + esc(l) + '</a>' : esc(l);
  };
  function priceConditions(p) {
    if (p.grossCents == null) return 'Pendiente de calcular el precio de esta pieza.';
    var parts = ['Precio orientativo con 21 % de IVA. Envío aparte.'];
    if (p.scale !== null && p.scale < 1) parts.push('Calculado para una escala del ' + Math.round(p.scale * 100) + ' % del modelo original.');
    if (p.isSet) parts.push('El informe valora un conjunto; confirmaremos las variantes y el contenido antes de fabricar.');
    if (p.hasLed) parts.push('El cálculo contempla un LED; su encaje se comprobará en la muestra.');
    parts.push('Medidas, acabado y presupuesto final sujetos a validación de fabricación.');
    return parts.join(' ');
  }
  function packPrice(ids) {
    var total = 0;
    for (var i = 0; i < ids.length; i++) {
      var p = find(ids[i]);
      if (!p || p.grossCents == null) return null;
      total += p.grossCents;
    }
    return total;
  }

  /* Selección guardada en el navegador (misma clave que la web). */
  var memory = '[]';
  function readSelection() {
    var raw;
    try { raw = localStorage.getItem(STORAGE); } catch (e) {}
    try {
      var saved = JSON.parse(raw || memory);
      return Array.isArray(saved) ? saved.filter(function (id) { return typeof id === 'string' && find(id); }) : [];
    } catch (e) { return []; }
  }
  function writeSelection(ids) {
    memory = JSON.stringify(ids);
    try { localStorage.setItem(STORAGE, memory); } catch (e) {}
    renderAll();
  }

  var state = { family: 0, query: '', sort: 'featured', active: null, selectionOpen: false, message: '', manualCopy: false };
  var grid = root.querySelector('[data-hw-grid]');
  var dialog = root.querySelector('[data-hw-dialog]');
  var dialogBody = root.querySelector('[data-hw-dialog-body]');
  var trigger = null;

  function filtered() {
    var q = normalize(state.query.trim());
    var list = models.filter(function (p) {
      return (!state.family || p.family === state.family) && normalize(p.name + ' ' + p.originalName + ' ' + p.category).indexOf(q) !== -1;
    });
    if (state.sort !== 'featured') {
      list.sort(function (a, b) {
        var x = a.grossCents, y = b.grossCents;
        if (x == null) return y == null ? 0 : 1;
        if (y == null) return -1;
        return state.sort === 'asc' ? x - y : y - x;
      });
    }
    return list;
  }

  function card(p, selected) {
    var b = buyable(p.id);
    var note = p.isSet ? 'Conjunto · contenido a confirmar' : (p.scale == null ? 1 : p.scale) < 1 ? 'Precio para formato reducido' : '';
    var priceNote = b ? '<small class="hw-price-note">IVA incluido</small>' : p.grossCents != null ? '<small class="hw-price-note">Orientativo · IVA incluido</small>' : '';
    var action = b
      ? '<a class="hw-card-buy" href="' + esc(b.url) + '">' + (b.soldOut ? 'Agotada' : 'Comprar ↗') + '</a>'
      : '<button type="button" data-hw-toggle="' + p.id + '" aria-label="' + (selected ? 'Quitar ' : 'Seleccionar ') + esc(p.name) + '">' + (selected ? '✓ Seleccionada' : '+ Seleccionar') + '</button>';
    return '<article class="hw-card" id="hw-' + p.id + '">' +
      '<button type="button" class="hw-card-photo" aria-label="Ver ' + esc(p.name) + '" data-hw-piece="' + p.id + '"><img src="' + photo(p) + '" alt="' + esc(p.name) + ', diseño de ' + esc(p.author) + '" loading="lazy" width="' + (p.cover ? 1000 : 640) + '" height="' + (p.cover ? 1000 : 480) + '"><span class="hw-card-index">HW / ' + p.id + '</span>' + (p.personal ? '<span class="hw-personal">TU MENSAJE AQUÍ</span>' : '') + '<span class="hw-card-arrow" aria-hidden="true">↗</span></button>' +
      '<div class="hw-card-body"><p class="hw-card-family">' + esc(p.category) + '</p><p class="hw-format-note">' + note + '</p>' +
      '<button type="button" class="hw-card-title" data-hw-piece="' + p.id + '"><h3>' + esc(p.name) + '</h3></button>' +
      '<div class="hw-card-bottom"><span>' + label(p) + priceNote + '</span>' + action + '</div>' +
      '<p class="hw-credit">Diseño de <a href="' + esc(p.source) + '" target="_blank" rel="noopener noreferrer">' + esc(p.author) + '</a> · ' + license(p.license) + '</p></div></article>';
  }

  function renderFilters() {
    var html = '<button type="button" aria-pressed="' + (state.family === 0) + '" data-hw-family="0">Todo <small>' + models.length + '</small></button>';
    GROUPS.forEach(function (g, i) {
      var n = models.filter(function (p) { return p.family === i + 1; }).length;
      html += '<button type="button" aria-pressed="' + (state.family === i + 1) + '" data-hw-family="' + (i + 1) + '">' + esc(g) + ' <small>' + n + '</small></button>';
    });
    root.querySelector('[data-hw-filters]').innerHTML = html;
  }

  function renderGrid() {
    var selected = readSelection();
    var list = filtered();
    grid.innerHTML = list.map(function (p) { return card(p, selected.indexOf(p.id) !== -1); }).join('');
    root.querySelector('[data-hw-status]').textContent = list.length + ' piezas ' + (state.family ? '· ' + GROUPS[state.family - 1] : 'para descubrir');
    root.querySelector('[data-hw-empty]').hidden = list.length > 0;
    root.querySelector('[data-hw-count]').textContent = selected.length;
  }

  function renderPacks() {
    root.querySelector('[data-hw-packs]').innerHTML = PACKS.map(function (pack, i) {
      var total = packPrice(pack.ids);
      return '<article class="hw-pack"><div class="hw-pack-photos">' +
        pack.ids.map(function (id) { var p = find(id); return '<img src="' + photo(p) + '" alt="' + esc(p.name) + '" loading="lazy">'; }).join('') +
        '</div><p class="hw-kicker">' + (i === 2 ? 'DESIGN BUSINESS' : 'COMPOSICIÓN 0' + (i + 1)) + '</p><h3>' + esc(pack.name) + '</h3><p>' + esc(pack.text) + '</p>' +
        '<p class="hw-pack-price">' + (total !== null ? euro(total) : 'A presupuestar') + '<small>Suma orientativa de las referencias · IVA incluido · Envío aparte</small></p>' +
        '<button type="button" class="hw-button" data-hw-pack="' + i + '">Preparar esta selección <span>↗</span></button></article>';
    }).join('');
  }

  function selectionText(chosen) {
    return 'Mi selección de Halloween · Aetheria Design\n' + chosen.map(function (p) { return '• ' + p.name + ' (ref. HW-' + p.id + ')'; }).join('\n') + '\nQuiero confirmar medidas, acabados, precio y plazo.';
  }

  function renderDialog() {
    var selected = readSelection();
    var p = state.active;
    if (p) {
      var b = buyable(p.id);
      dialog.setAttribute('aria-label', p.name);
      dialogBody.innerHTML = '<div class="hw-detail"><img src="' + photo(p) + '" alt="' + esc(p.name) + '"><div>' +
        '<p class="hw-kicker">' + esc(p.category) + '</p><h2>' + esc(p.name) + '</h2>' +
        '<p>' + esc(b ? b.description : p.description + '. Una propuesta para combinar con la colección y crear tu propia escena de Halloween.') + '</p>' +
        '<dl><div><dt>' + (b ? 'Precio' : 'Precio orientativo') + '</dt><dd>' + label(p) + '</dd></div>' +
        '<div><dt>' + (b ? 'Qué incluye' : 'Qué contempla el precio') + '</dt><dd>' + (b ? 'Pieza impresa en PLA y acabada a mano en Lugo. IVA incluido, envío aparte.' : esc(priceConditions(p))) + '</dd></div>' +
        '<div><dt>Diseño</dt><dd>' + esc(p.author) + '</dd></div></dl>' +
        (p.personal ? '<p>Cuéntanos el nombre o mensaje que te gustaría incluir. Confirmaremos el diseño antes de fabricar.</p>' : '') +
        (p.id === '132621' ? '<p>Pieza decorativa: no está validada para contacto con alimentos.</p>' : '') +
        (b
          ? '<a class="hw-button" href="' + esc(b.url) + '">' + (b.soldOut ? 'Ver ficha (agotada) ' : 'Comprar esta pieza ') + '<span>↗</span></a>'
          : '<button type="button" class="hw-button" data-hw-add="' + p.id + '">' + (selected.indexOf(p.id) !== -1 ? 'Añadida a tu selección ✓' : 'Añadir a mi selección +') + '</button>') +
        '<p role="status">' + esc(state.message) + '</p>' +
        '<p class="hw-credit"><a href="' + esc(p.source) + '" target="_blank" rel="noopener noreferrer">' + esc(p.originalName) + ' · Ver diseño original ↗</a><br>' + license(p.license) + (p.cover ? '. Imagen ilustrativa generada con IA a partir de la foto del autor.' : '. Imagen de referencia del autor.') + '</p></div></div>';
    } else if (state.selectionOpen) {
      var chosen = models.filter(function (m) { return selected.indexOf(m.id) !== -1; });
      var total = packPrice(chosen.map(function (m) { return m.id; }));
      dialog.setAttribute('aria-label', 'Mi selección de Halloween');
      dialogBody.innerHTML = '<div class="hw-selection"><p class="hw-kicker">TUS FAVORITOS</p><h2>Mi Halloween.</h2><p>Una selección de ideas para concretar tu presupuesto.</p>' +
        (chosen.length
          ? '<ul>' + chosen.map(function (m) { return '<li><img src="' + photo(m) + '" alt=""><span>' + esc(m.name) + '</span><button type="button" aria-label="Quitar ' + esc(m.name) + '" data-hw-remove="' + m.id + '">×</button></li>'; }).join('') + '</ul>' +
            '<p class="hw-selection-total">' + (total !== null ? 'Total orientativo: ' + euro(total) : 'Total pendiente: hay piezas sin precio') + '</p>' +
            '<p>IVA incluido. Envío aparte. El presupuesto final confirmará tamaños y contenido de los conjuntos.</p>' +
            '<button type="button" class="hw-button" data-hw-copy>Copiar selección</button>' +
            (state.manualCopy ? '<label>Texto de tu selección<textarea class="hw-selection-text" readonly>' + esc(selectionText(chosen)) + '</textarea></label>' : '')
          : '<p>Aún no has elegido ninguna pieza. Explora la colección y guarda tus favoritas.</p>') +
        '<p role="status">' + esc(state.message) + '</p><p class="hw-credit">Tu selección se guarda en este navegador. No genera un pedido.</p></div>';
    }
    if ((state.active || state.selectionOpen) && !dialog.open) dialog.showModal();
    if (!state.active && !state.selectionOpen && dialog.open) dialog.close();
  }

  function renderAll() { renderFilters(); renderGrid(); if (dialog.open || state.active || state.selectionOpen) renderDialog(); }

  function add(ids) {
    var selected = readSelection();
    ids.forEach(function (id) { if (selected.indexOf(id) === -1) selected.push(id); });
    state.message = ids.length > 1 ? 'Propuesta añadida a tu selección.' : 'Pieza añadida a tu selección.';
    writeSelection(selected);
  }
  function close() {
    state.active = null; state.selectionOpen = false; state.message = ''; state.manualCopy = false;
    if (dialog.open) dialog.close();
    if (trigger) trigger.focus();
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('button');
    if (!t) return;
    if (t.dataset.hwFamily !== undefined) { state.family = +t.dataset.hwFamily; renderAll(); }
    else if (t.dataset.hwPiece) { trigger = t; state.message = ''; state.selectionOpen = false; state.active = find(t.dataset.hwPiece); renderDialog(); }
    else if (t.dataset.hwToggle) {
      var id = t.dataset.hwToggle, sel = readSelection();
      if (sel.indexOf(id) !== -1) writeSelection(sel.filter(function (x) { return x !== id; }));
      else add([id]);
    }
    else if (t.dataset.hwPack) { trigger = t; add(PACKS[+t.dataset.hwPack].ids); state.active = null; state.selectionOpen = true; renderDialog(); }
    else if (t.hasAttribute('data-hw-open-selection')) { trigger = t; state.active = null; state.selectionOpen = true; renderDialog(); }
    else if (t.hasAttribute('data-hw-reset')) { state.family = 0; state.query = ''; root.querySelector('[data-hw-query]').value = ''; renderAll(); }
  });
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) { close(); return; }
    var t = e.target.closest('button');
    if (!t) return;
    if (t.hasAttribute('data-hw-close')) close();
    else if (t.dataset.hwAdd) add([t.dataset.hwAdd]);
    else if (t.dataset.hwRemove) { var id = t.dataset.hwRemove; writeSelection(readSelection().filter(function (x) { return x !== id; })); }
    else if (t.hasAttribute('data-hw-copy')) {
      var chosen = models.filter(function (m) { return readSelection().indexOf(m.id) !== -1; });
      var text = selectionText(chosen);
      (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject())
        .then(function () { state.message = 'Selección copiada. Puedes pegarla en tu consulta.'; renderDialog(); })
        .catch(function () { state.manualCopy = true; state.message = 'Mantén pulsado el texto de abajo para copiar tu selección.'; renderDialog(); });
    }
  });
  dialog.addEventListener('focusin', function (e) { if (e.target.matches('.hw-selection-text')) e.target.select(); });
  dialog.addEventListener('close', function () { if (state.active || state.selectionOpen) close(); });
  root.querySelector('[data-hw-query]').addEventListener('input', function (e) { state.query = e.target.value; renderGrid(); });
  root.querySelector('[data-hw-sort]').addEventListener('change', function (e) { state.sort = e.target.value; renderGrid(); });
  window.addEventListener('storage', function (e) { if (e.key === STORAGE) renderAll(); });

  renderFilters();
  renderGrid();
  renderPacks();
})();
